export default __webpack_public_path__ + "static/media/logo-senac.5ce52e52.png";